"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Storage", {
  enumerable: true,
  get: function get() {
    return _Storage.default;
  }
});
Object.defineProperty(exports, "Page", {
  enumerable: true,
  get: function get() {
    return _Page.default;
  }
});
Object.defineProperty(exports, "ModalFeedback", {
  enumerable: true,
  get: function get() {
    return _ModalFeedback.default;
  }
});
Object.defineProperty(exports, "AlertFeedback", {
  enumerable: true,
  get: function get() {
    return _AlertFeedback.default;
  }
});
Object.defineProperty(exports, "Navigation", {
  enumerable: true,
  get: function get() {
    return _Navigation.default;
  }
});
Object.defineProperty(exports, "NavigationArrows", {
  enumerable: true,
  get: function get() {
    return _NavigationArrows.default;
  }
});
Object.defineProperty(exports, "TaskAnimation", {
  enumerable: true,
  get: function get() {
    return _TaskAnimation.default;
  }
});
Object.defineProperty(exports, "TaskDragDrop", {
  enumerable: true,
  get: function get() {
    return _TaskDragDrop.default;
  }
});
Object.defineProperty(exports, "TaskBlank", {
  enumerable: true,
  get: function get() {
    return _TaskBlank.default;
  }
});
Object.defineProperty(exports, "TaskButton", {
  enumerable: true,
  get: function get() {
    return _TaskButton.default;
  }
});
Object.defineProperty(exports, "TaskExternal", {
  enumerable: true,
  get: function get() {
    return _TaskExternal.default;
  }
});
Object.defineProperty(exports, "TaskMultiChoice", {
  enumerable: true,
  get: function get() {
    return _TaskMultiChoice.default;
  }
});
Object.defineProperty(exports, "TaskSelect", {
  enumerable: true,
  get: function get() {
    return _TaskSelect.default;
  }
});
Object.defineProperty(exports, "TaskTest", {
  enumerable: true,
  get: function get() {
    return _TaskTest.default;
  }
});
Object.defineProperty(exports, "TaskScaleBuilder", {
  enumerable: true,
  get: function get() {
    return _ScaleBuilder.default;
  }
});
Object.defineProperty(exports, "ChordBuilder", {
  enumerable: true,
  get: function get() {
    return _ChordBuilder.default;
  }
});
Object.defineProperty(exports, "TaskMultiSelect", {
  enumerable: true,
  get: function get() {
    return _TaskMultiSelect.default;
  }
});
Object.defineProperty(exports, "TaskMultiSelectSubmit", {
  enumerable: true,
  get: function get() {
    return _TaskMultiSelectSubmit.default;
  }
});
Object.defineProperty(exports, "AudioPlayer", {
  enumerable: true,
  get: function get() {
    return _AudioPlayer.default;
  }
});
Object.defineProperty(exports, "TaskLikertScale", {
  enumerable: true,
  get: function get() {
    return _TaskLikertScale.default;
  }
});
Object.defineProperty(exports, "TaskSlider", {
  enumerable: true,
  get: function get() {
    return _TaskSlider.default;
  }
});
Object.defineProperty(exports, "TaskCallout", {
  enumerable: true,
  get: function get() {
    return _TaskCallout.default;
  }
});
Object.defineProperty(exports, "TaskTrueFalse", {
  enumerable: true,
  get: function get() {
    return _TaskTrueFalse.default;
  }
});
Object.defineProperty(exports, "TaskCarousel", {
  enumerable: true,
  get: function get() {
    return _TaskCarousel.default;
  }
});
Object.defineProperty(exports, "TaskRank", {
  enumerable: true,
  get: function get() {
    return _TaskRank.default;
  }
});
Object.defineProperty(exports, "TaskTabPanel", {
  enumerable: true,
  get: function get() {
    return _TaskTabPanel.default;
  }
});
exports.Stage = void 0;

var _Storage = _interopRequireDefault(require("./Storage"));

var _Page = _interopRequireDefault(require("./Page"));

var _ModalFeedback = _interopRequireDefault(require("./ModalFeedback"));

var _AlertFeedback = _interopRequireDefault(require("./AlertFeedback"));

var _Navigation = _interopRequireDefault(require("./Navigation"));

var _NavigationArrows = _interopRequireDefault(require("./NavigationArrows"));

var _TaskAnimation = _interopRequireDefault(require("./TaskAnimation"));

var _TaskDragDrop = _interopRequireDefault(require("./TaskDragDrop/TaskDragDrop"));

var _TaskBlank = _interopRequireDefault(require("./TaskBlank"));

var _TaskButton = _interopRequireDefault(require("./TaskButton"));

var _TaskExternal = _interopRequireDefault(require("./TaskExternal"));

var _TaskMultiChoice = _interopRequireDefault(require("./TaskMultiChoice/TaskMultiChoice"));

var _TaskSelect = _interopRequireDefault(require("./TaskSelect/TaskSelect"));

var _TaskTest = _interopRequireDefault(require("./TaskTest"));

var _ScaleBuilder = _interopRequireDefault(require("./TaskScaleBuilder/ScaleBuilder"));

var _ChordBuilder = _interopRequireDefault(require("./TaskScaleBuilder/ChordBuilder"));

var _TaskMultiSelect = _interopRequireDefault(require("./TaskMultiSelect/TaskMultiSelect"));

var _TaskMultiSelectSubmit = _interopRequireDefault(require("./TaskMultiSelect/TaskMultiSelectSubmit"));

var _AudioPlayer = _interopRequireDefault(require("./AudioPlayer/AudioPlayer"));

var _TaskLikertScale = _interopRequireDefault(require("./TaskLikertScale/TaskLikertScale"));

var _TaskSlider = _interopRequireDefault(require("./TaskSlider/TaskSlider"));

var _TaskCallout = _interopRequireDefault(require("./TaskCallout/TaskCallout"));

var _TaskTrueFalse = _interopRequireDefault(require("./TaskTrueFalse/TaskTrueFalse"));

var _TaskCarousel = _interopRequireDefault(require("./TaskCarousel/TaskCarousel"));

var _TaskRank = _interopRequireDefault(require("./TaskRank/TaskRank"));

var _TaskTabPanel = _interopRequireDefault(require("./TaskTabPanel/TaskTabPanel"));

require("bootstrap/dist/css/bootstrap.min.css");

require("react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css");

var _index = _interopRequireDefault(require("./index.scss"));

var Stage = _Page.default;
exports.Stage = Stage;